/* =========================================================
   Kents — scripts propios (vanilla, sin librerias)
   Se carga UNA sola vez desde layout/theme.liquid.
   Todas las inicializaciones estan protegidas para poder
   ejecutarse de nuevo cuando el editor recarga una seccion.
   ========================================================= */

(function () {
  'use strict';

  if (window.ktIniciado) return;
  window.ktIniciado = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Solo escondemos los elementos si el JS funciona: si algo falla,
  // la pagina se ve entera igualmente.
  if (!reduce) document.documentElement.classList.add('kt-anim');

  var observador = null;

  function mostrarTodo() {
    document.querySelectorAll('.kt-reveal').forEach(function (el) {
      el.classList.add('kt-visible');
    });
  }

  /* ----- Animaciones de entrada ----- */
  function initReveals() {
    var els = document.querySelectorAll('.kt-reveal:not(.kt-visible)');
    if (!els.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      mostrarTodo();
      return;
    }

    if (!observador) {
      observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (!e.isIntersecting) return;
          var el = e.target;
          var retardo = parseInt(el.getAttribute('data-kt-retardo') || '0', 10);
          setTimeout(function () { el.classList.add('kt-visible'); }, retardo);
          observador.unobserve(el);
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });
    }

    els.forEach(function (el) { observador.observe(el); });
  }

  /* ----- Carrusel de colores ----- */
  function initCarruseles() {
    document.querySelectorAll('[data-kt-carrusel]').forEach(function (wrap) {
      if (wrap.dataset.ktListo === '1') return;
      var pista = wrap.querySelector('[data-kt-pista]') || wrap.querySelector('.kt-colores__pista');
      if (!pista) return;
      wrap.dataset.ktListo = '1';

      var prev = wrap.querySelector('[data-kt-prev]');
      var next = wrap.querySelector('[data-kt-next]');

      function paso() {
        var tarjeta = pista.querySelector('[data-kt-tarjeta]') || pista.querySelector('.kt-color');
        return tarjeta ? tarjeta.getBoundingClientRect().width + 20 : 300;
      }
      if (prev) prev.addEventListener('click', function () {
        pista.scrollBy({ left: -paso(), behavior: reduce ? 'auto' : 'smooth' });
      });
      if (next) next.addEventListener('click', function () {
        pista.scrollBy({ left: paso(), behavior: reduce ? 'auto' : 'smooth' });
      });
    });
  }

  /* ----- FAQ acordeon ----- */
  function initFaq() {
    document.querySelectorAll('.kt-faq__item').forEach(function (item) {
      if (item.dataset.ktListo === '1') return;
      var boton = item.querySelector('.kt-faq__boton');
      var panel = item.querySelector('.kt-faq__panel');
      if (!boton || !panel) return;
      item.dataset.ktListo = '1';

      boton.addEventListener('click', function () {
        var abierto = item.classList.contains('kt-abierto');

        item.parentElement.querySelectorAll('.kt-faq__item.kt-abierto').forEach(function (h) {
          if (h === item) return;
          h.classList.remove('kt-abierto');
          var p = h.querySelector('.kt-faq__panel');
          var b = h.querySelector('.kt-faq__boton');
          if (p) p.style.height = '0px';
          if (b) b.setAttribute('aria-expanded', 'false');
        });

        if (abierto) {
          item.classList.remove('kt-abierto');
          panel.style.height = '0px';
          boton.setAttribute('aria-expanded', 'false');
        } else {
          item.classList.add('kt-abierto');
          panel.style.height = panel.scrollHeight + 'px';
          boton.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ----- Galeria de la pagina de producto ----- */
  function initGaleria() {
    document.querySelectorAll('[data-kt-galeria]').forEach(function (g) {
      if (g.dataset.ktListo === '1') return;
      var principal = g.querySelector('[data-kt-principal]');
      var minis = g.querySelectorAll('[data-kt-mini]');
      if (!principal || !minis.length) return;
      g.dataset.ktListo = '1';

      minis.forEach(function (mini) {
        mini.addEventListener('click', function () {
          var src = mini.getAttribute('data-kt-src');
          if (src) principal.setAttribute('src', src);
          minis.forEach(function (m) { m.classList.remove('kt-activa'); });
          mini.classList.add('kt-activa');
        });
      });
    });
  }

  /* ----- Selector de variantes ----- */
  function initVariantes() {
    document.querySelectorAll('[data-kt-variantes]').forEach(function (form) {
      if (form.dataset.ktListo === '1') return;
      form.dataset.ktListo = '1';

      var botones = form.querySelectorAll('[data-kt-variante]');
      var input = form.querySelector('[data-kt-variante-id]');
      var precio = document.querySelector('[data-kt-precio]');
      var etiqueta = document.querySelector('[data-kt-variante-nombre]');
      var galeria = document.querySelector('[data-kt-galeria]');

      botones.forEach(function (b) {
        b.addEventListener('click', function () {
          if (b.hasAttribute('disabled')) return;
          botones.forEach(function (x) { x.classList.remove('kt-activa'); });
          b.classList.add('kt-activa');
          if (input) input.value = b.getAttribute('data-kt-variante');
          if (etiqueta) etiqueta.textContent = b.getAttribute('data-kt-nombre') || '';
          if (precio && b.getAttribute('data-kt-precio-variante')) {
            precio.textContent = b.getAttribute('data-kt-precio-variante');
          }
          var img = b.getAttribute('data-kt-imagen');
          if (img && galeria) {
            var principal = galeria.querySelector('[data-kt-principal]');
            if (principal) principal.setAttribute('src', img);
            galeria.querySelectorAll('[data-kt-mini]').forEach(function (m) {
              m.classList.toggle('kt-activa', m.getAttribute('data-kt-src') === img);
            });
          }
        });
      });
    });
  }

  /* ----- Reajuste de paneles abiertos ----- */
  window.addEventListener('resize', function () {
    document.querySelectorAll('.kt-faq__item.kt-abierto .kt-faq__panel').forEach(function (p) {
      p.style.height = p.scrollHeight + 'px';
    });
  });

  function init() {
    try {
      initReveals();
      initCarruseles();
      initFaq();
      initGaleria();
      initVariantes();
    } catch (e) {
      // Si algo falla, que al menos la pagina se vea entera.
      mostrarTodo();
    }
  }

  // Red de seguridad: pase lo que pase, a los 2,5 s todo es visible.
  setTimeout(mostrarTodo, 2500);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', init);
})();
